import PropTypes from 'prop-types';
import { TabBar } from 'components';
import NotificationCard from './Components/NotificationCard/NotificationCard';
import { useNotifications } from './hooks/useNotifications';
import { NOTIFICATION_TABS } from './constants';

import './Notifications.scss';
const Notifications = ({ onSelectNotification, selectedNotificationId }) => {
  const { filter, handleTabChange, notifications, markAsRead } =
    useNotifications();

  const hasNotifications = Array.isArray(notifications) && notifications.length;

  return (
    <div className='notifications-scroller'>
      <div className='notifications-container pr-2'>
        <TabBar
          tabs={NOTIFICATION_TABS}
          activeTab={filter}
          onTabChange={handleTabChange}
        />

        <div className='notifications-grid'>
          {hasNotifications ? (
            notifications.map((notification) => (
              <NotificationCard
                key={notification.id}
                notification={notification}
                markAsRead={markAsRead}
                onSelect={onSelectNotification}
                isSelected={
                  Boolean(selectedNotificationId) &&
                  String(selectedNotificationId) === String(notification.id)
                }
              />
            ))
          ) : (
            <div className='notifications-empty'>You're all caught up!</div>
          )}
        </div>
      </div>
    </div>
  );
};

Notifications.propTypes = {
  onSelectNotification: PropTypes.func,
  selectedNotificationId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

export default Notifications;
